require('./RACover.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { EditAlias } = require('commonsComponents/editAlias');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const LabelWithEllipses = require('../LabelWithEllipses/LabelWithEllipses');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

//@helper
const { sendTextToClipBoard } = require('utilities/clipBoardHelper');
const { getLastNChars } = require('utilities/stringHelper');

class RACover extends React.Component {
    buildHelp() {
        const { helpContent } = this.props;
        let content = (
            <FormattedText
                value="broker-helpText"
                className="ra-cover__section-right-content"
            />
        );

        if (helpContent) {
            content = helpContent;
        }
        return <div className="ra-cover__section-right">{content}</div>;
    }

    buildRightContent(rightContent) {
        return (
            <div className="ra-cover__header-right-content">{rightContent}</div>
        );
    }

    buildTitle() {
        const {
            title,
            titleEditable,
            titleEditLimit,
            onUpdateTitle,
            fontSize,
            errorTitle,
            errorTitleMessage,
        } = this.props;
        if (titleEditable) {
            return (
                <div className="ra-cover__edit-alias">
                    <EditAlias
                        alias={title}
                        postAlias={onUpdateTitle}
                        limit={titleEditLimit}
                        isHeading={true}
                        fontSize={fontSize}
                        error={errorTitle}
                        errorMessage={errorTitleMessage}
                    />
                </div>
            );
        } else {
            // Used <LabelWithEllipses/> component for overflowing text.
            // which returns text with ellipses and showing tooltip while hovering
            return (
                <LabelWithEllipses
                    extraClasses="ra-cover__header-title" //added class having required CSS and width
                    text={title}
                />
            );
        }
    }

    buildCGDNumber(cgdNumber, iconTitle) {
        const lastFourDigitOfNumber = getLastNChars(cgdNumber, 4);
        const classNameForCgd = iconTitle
            ? 'ra-cover__cgd-subtitle--portfolio ra-cover__cgd-subtitle'
            : 'ra-cover__cgd-subtitle';
        const cgdText =
            formatText('raAccountDetail-cgdText') + lastFourDigitOfNumber;
        const target = <div className={classNameForCgd}>{cgdText} </div>;
        const content = (
            <span>
                {cgdNumber}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={() => sendTextToClipBoard(cgdNumber)}
                />
            </span>
        );
        return (
            <div>
                {target}
                <OKTooltip
                    content={content}
                    offset={[0, -15]}
                    target={target}
                />
            </div>
        );
    }

    buildHeaderSubPage() {
        const {
            breadcrumb,
            showHelp,
            subtitle,
            success,
            successTitle,
            successSubtitle,
            iconTitle,
            rightContent,
            overlap,
            errorTitle,
        } = this.props;
        let content;

        if (success) {
            content = (
                <div className="ra-cover__header-success-container">
                    <div className="ra-cover__header-success-icon">
                        <i className="ra-cover__icon-success icon icon-tilde-circulo" />
                    </div>
                    <div className="ra-cover__header-success-title">
                        {successTitle}
                    </div>
                    <div className="ra-cover__header-success-info">
                        {successSubtitle}
                    </div>
                </div>
            );
        } else {
            const helpBlock = showHelp ? this.buildHelp() : null;
            const rightSection = rightContent
                ? this.buildRightContent(rightContent)
                : null;
            let subtitleBlock;
            if (!!subtitle) {
                const classNameForSubtitle = iconTitle
                    ? 'ra-cover__header-subtitle--portfolio ra-cover__header-subtitle'
                    : 'ra-cover__header-subtitle';
                const subtitleClassName = classNames(classNameForSubtitle, {
                    'ra-cover__header-subtitle--error': errorTitle,
                });
                subtitleBlock = (
                    <div className={subtitleClassName}>{subtitle}</div>
                );
            }

            content = (
                <div className="ra-cover__header-container">
                    <div className="ra-cover__header-content">
                        <h2 className="ra-cover__header-title">
                            {iconTitle}
                            {this.buildTitle()}
                        </h2>
                    </div>
                    {subtitleBlock}
                    {helpBlock}
                    {rightSection}
                </div>
            );
        }

        return (
            <OKHeaderSubPage
                breadcrumbConfig={breadcrumb}
                hasTitle={false}
                isSubtitleLeftCapital={false}
                overlap={overlap}
            >
                {content}
            </OKHeaderSubPage>
        );
    }

    render() {
        const { section, goalType } = this.props;

        const headerSubPage = this.buildHeaderSubPage();
        const sectionName = /*section || */ 'generic';
        const coverClassName = classNames('col-xs-12 ra-cover', {
            [`ra-ok-cover--${section}`]: section,
            [`ra-cover--${goalType.toLowerCase()}`]: !!goalType, ////Added for temp purpose need to confirm about RACover & RAOKCover
        });
        return (
            <OKCover customClass={coverClassName} section={sectionName}>
                {headerSubPage}
            </OKCover>
        );
    }
}

RACover.propTypes = {
    breadcrumb: PropTypes.array,
    helpContent: PropTypes.element,
    iconTitle: PropTypes.element,
    rightContent: PropTypes.object,
    errorTitle: PropTypes.bool,
    errorTitleMessage: PropTypes.string,
    goalType: PropTypes.string,
    section: PropTypes.string,
    showHelp: PropTypes.bool,
    subtitle: PropTypes.string,
    success: PropTypes.bool,
    successSubtitle: PropTypes.string,
    successTitle: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    titleEditable: PropTypes.bool.isRequired,
    titleEditLimit: PropTypes.number,
    onUpdateTitle: PropTypes.func,
    overlap: PropTypes.bool,
    fontSize: PropTypes.string,
};

RACover.defaultProps = {
    showHelp: false,
    subtitle: '',
    success: false,
    successTitle: '',
    titleEditable: false,
    titleEditLimit: 50,
    errorTitle: false,
    errorTitleMessage: '',
    goalType: '',
    overlap: true,
    fontSize: '28px PrimaryFontBold',
};

module.exports = RACover;
